import React, { useState } from "react";
import axios from "axios";
import { useParams, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicSurvey() {
  const { slug } = useParams();
  const [sp] = useSearchParams();
  const sid = sp.get("sid") || "";
  const [done, setDone] = useState(false);
  const [form, setForm] = useState({ signin_id: sid, rating: 5, liked: "", concerns: "", timeline: "" });

  const submit = async (e) => {
    e.preventDefault();
    try {
      const payload = { signin_id: form.signin_id || "", rating: form.rating, liked: form.liked, concerns: form.concerns, timeline: form.timeline };
      await axios.post(`${API}/public/open-house/${slug}/survey`, payload);
      setDone(true);
      toast.success("Thanks for the feedback");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Failed to submit — please try again");
    }
  };

  return (
    <div className="min-h-screen bg-[#ffffff]" data-testid="public-survey-page">
      <header className="bg-[#e1b7c1] px-5 py-6 text-center"><Logo variant="white" height={56} /></header>
      <div className="max-w-lg mx-auto px-4 py-8">
        <div className="overline">Post-Visit Survey</div>
        <h1 className="font-heading text-3xl mt-2 mb-4">Quick 30-second feedback</h1>
        {done ? (
          <div className="bg-white border border-[#d1cece] rounded-lg p-6 text-center">
            <h3 className="font-heading text-2xl">Thank you!</h3>
            <p className="text-sm text-[#050303]/70 mt-2">The seller and their agent appreciate your honest feedback.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white border border-[#d1cece] rounded-lg p-6 space-y-4" data-testid="survey-form">
            <div>
              <label className="text-xs uppercase tracking-wider text-[#050303]/70 block mb-2">Overall impression (1–5)</label>
              <div className="flex gap-2">
                {[1, 2, 3, 4, 5].map(n => (
                  <button key={n} type="button" onClick={() => setForm({ ...form, rating: n })}
                    className={`w-12 h-12 rounded-full text-lg font-bold ${form.rating === n ? "bg-[#050303] text-white" : "bg-white border border-[#d1cece]"}`}
                    data-testid={`survey-rating-${n}`}>{n}</button>
                ))}
              </div>
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-[#050303]/70 block mb-1">What did you like most?</label>
              <textarea rows={2} value={form.liked} onChange={e => setForm({ ...form, liked: e.target.value })} className="w-full px-3 py-2 border border-[#d1cece] rounded-md" data-testid="survey-liked" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-[#050303]/70 block mb-1">Any concerns or hesitations?</label>
              <textarea rows={2} value={form.concerns} onChange={e => setForm({ ...form, concerns: e.target.value })} className="w-full px-3 py-2 border border-[#d1cece] rounded-md" data-testid="survey-concerns" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-[#050303]/70 block mb-1">Buying / selling timeline?</label>
              <select value={form.timeline} onChange={e => setForm({ ...form, timeline: e.target.value })} className="w-full px-3 py-2 border border-[#d1cece] rounded-md" data-testid="survey-timeline">
                <option value="">Select…</option>
                <option>Ready now (0–30 days)</option>
                <option>Soon (1–3 months)</option>
                <option>Later (3–6 months)</option>
                <option>Just browsing</option>
              </select>
            </div>
            <button type="submit" className="w-full bg-[#050303] text-white pill-btn py-3" data-testid="survey-submit">Submit feedback</button>
          </form>
        )}
      </div>
    </div>
  );
}
